export const version = 'kunde-v1.20.0-SNAPSHOT-07187d28bdd33405200a4dc4d0129ea0d2c18725';